import script from "./PollEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./PollEditor.vue?vue&type=script&setup=true&lang=ts"

import "./PollEditor.vue?vue&type=style&index=0&id=6ff4bdf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff4bdf8"]])

export default __exports__